import { FaHtml5, FaCss3Alt, FaJsSquare, FaReact, FaVuejs, FaNodeJs, FaGithub, FaWordpress } from 'react-icons/fa';
import { SiNextdotjs, SiGatsby, SiGraphql, SiTailwindcss, SiMongodb, SiElementor, SiExpress, SiCodeigniter } from 'react-icons/si';

export const skills = [
  { name: 'HTML', icon: <FaHtml5 /> },
  { name: 'CSS/SCSS', icon: <FaCss3Alt /> },
  { name: 'Tailwind CSS', icon: <SiTailwindcss /> },
  { name: 'JavaScript', icon: <FaJsSquare /> },
  { name: 'React JS', icon: <FaReact /> },
  { name: 'Vue.js', icon: <FaVuejs /> },
  { name: 'Next JS', icon: <SiNextdotjs /> },
  { name: 'Gatsby JS', icon: <SiGatsby /> },
  { name: 'WordPress', icon: <FaWordpress /> },
  { name: 'Elementor', icon: <SiElementor /> },
  { name: 'Node JS', icon: <FaNodeJs /> },
  { name: 'Express JS', icon: <SiExpress /> },
  { name: 'CodeIgniter', icon: <SiCodeigniter /> },
  { name: 'GraphQL', icon: <SiGraphql /> },
  { name: 'MongoDB', icon: <SiMongodb /> },
  { name: 'GitHub', icon: <FaGithub /> },
];

export const socialLinks = {
  github: "https://github.com/pepi05",
  linkedin: "https://www.linkedin.com/in/petar-gjuzelov-589720219/",
  email: "pepi_guzelov@hotmail.com"
};

export const education = [
  {
    institution: "Semos Education",
    degree: "JavaScript Academy - Certified JavaScript Programmer",
    date: "2020 - 2021",
    desc: "Completed a comprehensive program covering full-stack web development. Gained hands-on experience with React for frontend development, Node.js and MongoDB for backend and database management, and modern web technologies including HTML, CSS, and JavaScript. Developed practical projects demonstrating the ability to build dynamic, responsive, and full-stack web applications."
  },
  {
    institution: "Goce Delchev University",
    degree: "Bachelor's degree in Computer Science",
    date: "2014 - 2020",
    desc: "Foundation of computer science, algorithms, and software engineering principles."
  }
];

export const experience = [
{
  company: "Adamantus",
  role: "Front-End Engineer",
  date: "09/2023 - 04/2026",
  desc: "Responsible for implementing responsive web applications for the BARKODER project, primarily using Vue.js to translate Figma designs into functional, pixel-perfect user interfaces. Developed sample applications for Barkoder project using React.js and Vue.js paired with CodeIgniter. Contributed to various CMS projects, focusing on performance optimization and user experience, and worked on several WordPress projects."
},
  {
    company: "Dorms.com (Freelance)",
    role: "Front-End Developer",
    date: "05/2024 - 10/2025",
    desc: "Worked on a global booking platform. Translated Figma designs into production-ready pages and integrated dynamic data from a PHP (CodeIgniter) backend."
  },
  {
    company: "Anant Macedonia",
    role: "Full-Stack Developer",
    date: "02/2022 - 04/2023",
    desc: "Developed modern, responsive web applications using Next.js with Headless WordPress, building fast and SEO-friendly websites. Built Wordpress/Elementor website. Created dynamic websites and landing pages using Gatsby.js with GraphQL for efficient data fetching and optimized performance. Collaborated with design and backend teams to implement features, ensuring pixel-perfect UI and seamless user experience."
  },
  {
    company: "Produkto.io",
    role: "Full-Stack Developer (Intern)",
    date: "10/2021 - 01/2022",
    desc: "Completed a 3-month internship where I worked on frontend development using React and Redux to build dynamic, state-driven user interfaces. Gained hands-on experience with backend development using Node.js/Express, focusing on API integrations and server-side logic. Styled website with SCSS, ensuring clean and responsive designs. Contributed to the company's main project, 'Space Logo', by implementing features across both frontend (React) and backend (Node.js), improving user experience and functionality."
  }
];

export const projects = [
  // ADAMANTUS WORK
  {
    slug: "barkoder",
    title: "barKoder",
    category: "Professional",
    company: "Adamantus",
    description: "Enterprise-grade barcode scanner integration.",
    role: "Front-End Engineer",
    whatIDid: "Implemented Figma designs into responsive web interfaces using Vue.js. Built sample web applications with Vue.js and React to demonstrate the scanning SDK. Collaborated with backend using CodeIgniter and SQL to integrate functionalities and manage data.",
    link: "https://barkoder.com/",
    tags: ["Vue.js", "React", "CodeIgniter", "Figma"],
    technologies: ["Vue.js", "React", "SCSS", "Figma", "CodeIgniter", "SQL"]
  },
  {
    slug: "laser-appraiser",
    title: "Laser Appraiser",
    category: "Professional",
    company: "Adamantus",
    description: "Vehicle valuation and market data platform.",
    role: "Front-End Developer",
    whatIDid: "Updated existing user interfaces and implemented new designs for real-time vehicle valuations and VIN scanning features using a custom company CMS and JavaScript.",
    link: "https://laserappraiser.com/",
    tags: ["JavaScript", "Custom CMS"],
    technologies: ["JavaScript", "CSS", "Custom CMS"]
  },
  {
    slug: "the-book-office",
    title: "The Book Office",
    category: "Professional",
    company: "Adamantus",
    description: "Refined business service platform.",
    role: "WordPress Developer",
    whatIDid: "Built and maintained the website using WordPress and Elementor, ensuring a mobile-first approach and high visual fidelity based on client requirements.",
    link: "https://thebookoffice.com/",
    tags: ["WordPress", "Elementor"],
    technologies: ["WordPress", "Elementor", "Responsive Design"]
  },
  {
    slug: "barefoot-team",
    title: "Team Barefoot",
    category: "Professional",
    company: "Adamantus",
    description: "Collaborative platform website.",
    role: "WordPress Developer",
    whatIDid: "Built and maintained the website using WordPress and Elementor, focusing on performance and user-friendly navigation.",
    link: "https://barefoot.team/",
    tags: ["WordPress", "Elementor"],
    technologies: ["WordPress", "Elementor"]
  },

  // DORMS WORK
  {
    slug: "dorms-com",
    title: "Dorms.com",
    category: "Professional",
    company: "Dorms.com",
    description: "Global hostel and student booking platform.",
    role: "Front-End Developer",
    whatIDid: "Translated Figma designs into production-ready pages. Integrated dynamic data from the PHP (CodeIgniter) backend to ensure accurate content rendering.",
    link: "https://www.dorms.com/",
    tags: ["JavaScript", "CodeIgniter", "CSS"],
    technologies: ["HTML5", "CSS3", "JavaScript", "PHP", "CodeIgniter"]
  },

  // ANANT WORK
  {
    slug: "cassandra-link",
    title: "Cassandra Link",
    category: "Professional",
    company: "Anant",
    description: "The knowledge base for the Apache Cassandra community.",
    role: "Front-End Engineer",
    whatIDid: "Built using Gatsby.js and GraphQL. Responsible for creating the UI and managing high volumes of technical data indexed for search.",
    link: "https://cassandra.link/",
    tags: ["Gatsby.js", "GraphQL", "CSS"],
    technologies: ["Gatsby.js", "GraphQL", "Algolia", "CSS"], 
  },
  {
    slug: "cassandra-tools",
    title: "Cassandra Tools",
    category: "Professional",
    company: "Anant",
    description: "Curated tools and resources for Cassandra users.",
    role: "Front-End Engineer",
    whatIDid: "Developed the UI using Gatsby.js and integrated data sources via GraphQL to provide a fast, searchable directory of tools.",
    link: "https://cassandra.tools/",
    tags: ["Gatsby.js", "GraphQL"],
    technologies: ["Gatsby.js", "GraphQL", "CSS"]
  },
  {
    slug: "anant-us",
    title: "Anant.us",
    category: "Professional",
    company: "Anant",
    description: "Official company website for Anant.",
    role: "Front-End Developer",
    whatIDid: "Built using WordPress and Elementor. Focused on corporate branding and service presentation.",
    link: "https://anant.us/",
    tags: ["WordPress", "Elementor"],
    technologies: ["WordPress", "Elementor", "CSS"]
  },

  // PERSONAL PROJECTS
  {
    slug: "pg-shop",
    title: "PG Shop",
    category: "Personal",
    company: "Personal Project",
    description: "Modern E-commerce application with full shopping cart functionality.",
    role: "Developer",
    whatIDid: "Developed a responsive e-commerce application using React 18 and Tailwind CSS, implementing real-time product search and category filters. Built an animated slide-out shopping cart with Framer Motion for an app-like experience. Managed state with Zustand for dynamic collection updates and smart pagination. Integrated Supabase for user authentication and order persistence, enabling secure login, registration, and account dashboards. Designed detailed product pages with multi-image galleries, live stock status, and customer reviews, ensuring a smooth and interactive shopping experience.",
    link: "https://pg-shop.vercel.app/",
    tags: ["React", "Tailwind", "Supabase"],
    technologies: ["React JS", "Tailwind CSS", "Zustand", "Supabase"]
  },
  {
    slug: "nutri-plan",
    title: "Nutri Plan",
    category: "Personal",
    company: "Personal Project",
    description: "Health and nutrition planning application.",
    role: "Developer",
    whatIDid: "Built the frontend using Next.js 15 and React Context API, implementing responsive UI and dynamic routing for SEO-friendly recipe pages. Integrated Supabase for authentication, database, and storage. Developed full CRUD functionality for recipes with image uploads. Created a weekly meal planner with per-user persistence using LocalStorage. Implemented a smart grocery algorithm to merge ingredients across the weekly plan. Ensured performance, security (RLS policies), and smooth animations with Framer Motion.",
    link: "https://nutri-plan-pg.vercel.app/",
    tags: ["Next.js", "Tailwind", "Supabase"],
    technologies: ["Next.js", "React Context API", "Tailwind CSS", "Supabase"]
  }
];